import type { Attachment } from 'svelte/attachments';

// Starts a muted autoplay video the first time it scrolls into view, so its file is only
// downloaded for visitors who reach it. After that it plays (and loops) as a native autoplay would.
export const playWhenVisible: Attachment<HTMLVideoElement> = (video) => {
	const observer = new IntersectionObserver(([entry]) => {
		if (!entry?.isIntersecting) {
			return;
		}

		observer.disconnect();
		// The browser can still refuse (data saver, low power mode); the controls stay usable.
		video.play().catch(() => undefined);
	});

	observer.observe(video);

	return () => observer.disconnect();
};
